import { MainConcernValue } from '@cureskin/api-client/src/server-api/api';

export const MALE_HAIRFALL_STAGES_QUESTION_ID = 'MaleHairfallStages';
export const FEMALE_HAIRFALL_STAGES_QUESTION_ID = 'FemaleHairfallStages';

export const CONCERN_SPECIFIC_QUESTION_IDS: Readonly<Record<string, { Female: string[], Male: string[] }>> = {
  [MainConcernValue.HAIR_LOSS]: {
    Female: [FEMALE_HAIRFALL_STAGES_QUESTION_ID],
    Male: [MALE_HAIRFALL_STAGES_QUESTION_ID],
  },
};

const SELECT_HAIRFALL_STAGE = $localize`:@@selectYourHairfallStage:Select your Hairfall Stage`;

export const CONCERN_SPECIFIC_QUESTION_COPY: Readonly<Record<string, string>> = {
  [FEMALE_HAIRFALL_STAGES_QUESTION_ID]: SELECT_HAIRFALL_STAGE,
  [MALE_HAIRFALL_STAGES_QUESTION_ID]: SELECT_HAIRFALL_STAGE,
};
